module.exports = __webpack_public_path__ + "e9114d2cd34fb7625cb892840f40aa47.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/MyriadPro-Regular.ttf
// module id = 167
// module chunks = 0